var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { v4 as uuidv4 } from 'uuid';
import { getCurrentScene, setShapes, setPressingMode } from "../../../redux/actions/canvas/canvas";
import store from "../../../redux/store";
import { addCommand } from '../../history/HistoryService';
// Переменные для хранения начальной точки рисования
var drawStartX = null;
var drawStartY = null;
// Функция для вычисления координат фигуры
var calculateShapePoints = function (shapeType, startX, startY, endX, endY, isShiftPressed) {
    switch (shapeType) {
        case 'rectangle': {
            var width = endX - startX;
            var height = endY - startY;
            if (isShiftPressed) {
                // Делаем квадрат
                var size = Math.min(Math.abs(width), Math.abs(height));
                width = width >= 0 ? size : -size;
                height = height >= 0 ? size : -size;
            }
            return [startX, startY, width, height];
        }
        case 'circle': {
            var centerX = startX;
            var centerY = startY;
            var radiusX = Math.abs(endX - startX);
            var radiusY = Math.abs(endY - startY);
            if (isShiftPressed) {
                // Делаем круг (одинаковые радиусы)
                var radius = Math.min(radiusX, radiusY);
                radiusX = radius;
                radiusY = radius;
            }
            return [centerX, centerY, radiusX, radiusY];
        }
        case 'triangle': {
            // Прямоугольный треугольник
            return [
                startX, startY,
                endX, startY,
                endX, endY // нижняя правая (прямой угол)
            ];
        }
        case 'triangle-custom': {
            // Равнобедренный треугольник
            var centerX = startX + (endX - startX) / 2;
            return [
                centerX, startY,
                startX, endY,
                endX, endY // нижняя правая
            ];
        }
        case 'trapezoid': {
            var offset = Math.abs(endX - startX) * 0.2; // 20% от ширины
            return [
                startX + offset, startY,
                endX - offset, startY,
                endX, endY,
                startX, endY // нижняя левая
            ];
        }
        case 'rhombus': {
            // Ромб - четыре вершины: сверху, справа, снизу, слева
            var centerX = startX + (endX - startX) / 2;
            var centerY = startY + (endY - startY) / 2;
            return [
                centerX, startY,
                endX, centerY,
                centerX, endY,
                startX, centerY // левая точка
            ];
        }
        case 'parallelogram': {
            // Параллелограмм - наклонный прямоугольник
            var offset = Math.abs(endX - startX) * 0.25; // 25% от ширины для наклона
            return [
                startX + offset, startY,
                endX + offset, startY,
                endX, endY,
                startX, endY // нижняя левая
            ];
        }
        case 'coordinate-system': {
            // Система координат - центр и размер
            var centerX = startX;
            var centerY = startY;
            var width = Math.abs(endX - startX);
            var height = Math.abs(endY - startY);
            var size = Math.max(width, height);
            return [centerX, centerY, size];
        }
        case 'parallelepiped': {
            // Параллелепипед - 3D прямоугольник в перспективе
            var width = endX - startX;
            var height = endY - startY;
            // Смещение для создания 3D эффекта (примерно 25% от размеров)
            var offsetX = Math.abs(width) * 0.25;
            var offsetY = Math.abs(height) * 0.25;
            return [startX, startY, width, height, offsetX, offsetY];
        }
        default:
            return [];
    }
};
export var start = function (event) {
    var _a = store.getState().canvas, cameraOffset = _a.cameraOffset, scale = _a.scale, activeShapeType = _a.activeShapeType, shapeAttrs = _a.shapeAttrs;
    var scene = getCurrentScene();
    if (!scene)
        return;
    var pos = event.target.getStage().getPointerPosition();
    var adjustedPos = {
        x: (pos.x - cameraOffset.x) / scale,
        y: (pos.y - cameraOffset.y) / scale
    };
    // Сохраняем начальную точку рисования
    drawStartX = adjustedPos.x;
    drawStartY = adjustedPos.y;
    var id = uuidv4();
    // Создаем фигуру с минимальным размером
    var initialPoints = calculateShapePoints(activeShapeType, adjustedPos.x, adjustedPos.y, adjustedPos.x + 1, adjustedPos.y + 1, false);
    var newShape = {
        id: id,
        tool: 'shape',
        shapeType: activeShapeType,
        points: initialPoints,
        attr: __assign({}, shapeAttrs),
        time: new Date()
    };
    scene.shapes.push(newShape);
    setShapes(scene.shapes);
    setPressingMode(true);
    // Добавляем команду в историю
    addCommand('ADD_SHAPE', { id: id });
};
export var move = function (event) {
    var _a;
    var _b = store.getState().canvas, cameraOffset = _b.cameraOffset, scale = _b.scale, activeShapeType = _b.activeShapeType, isPressed = _b.isPressed;
    var scene = getCurrentScene();
    if (!scene || !isPressed || scene.shapes.length === 0)
        return;
    if (drawStartX === null || drawStartY === null)
        return;
    var pos = event.target.getStage().getPointerPosition();
    var adjustedPos = {
        x: (pos.x - cameraOffset.x) / scale,
        y: (pos.y - cameraOffset.y) / scale
    };
    var lastShape = scene.shapes[scene.shapes.length - 1];
    // Проверяем Shift
    var isShiftPressed = ((_a = event.evt) === null || _a === void 0 ? void 0 : _a.shiftKey) || false;
    // Пересчитываем points используя сохраненную начальную точку
    var newPoints = calculateShapePoints(activeShapeType, drawStartX, drawStartY, adjustedPos.x, adjustedPos.y, isShiftPressed);
    lastShape.points = newPoints;
    setShapes(scene.shapes);
};
export var finish = function (event) {
    setPressingMode(false);
    // Очищаем сохраненную начальную точку
    drawStartX = null;
    drawStartY = null;
};
